/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleDetections.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRuleDetectionsTestIds = {
  btnClearRuleFilter: "btn-clear-rule-filter",
  colDetectionStartedAt: "col-detection-started-at",
  colIdentitiesEvaluated: "col-identities-evaluated",
  colRule: "col-rule",
  colStatus: "col-status",
  colViolationsFound: "col-violations-found",
  colViolationsResolved: "col-violations-resolved",
  restrictionRuleDetections: "restriction-rule-detections",
  linkRuleDetail: (entry_ruleId: string) => `link-rule-detail-${entry_ruleId}`,
  linkRuleDetailPrefix: () => "link-rule-detail-" as TestIdPrefix
} as const;
